import { useEffect, useState } from "react";
import "./Settings.scss";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import AdjustFontsize from "../AdjustFontsize/AdjustFontsize";
import { ThemesToggler } from "../ThemesToggler/ThemesToggler";
import { useAppDispatch, useAppSelector } from "../../../services/hooks.service";
import { saveChangeGridLayout, saveFontSizeLayout, saveLockLayout, saveMobileTab } from "../../../redux/_actions/persist.action";
import { CUSTOMISE_VIEW_LIST, FONT_LAYOUT, GRID_LAYOUT } from "../../../constants/grid.layout";
import { ReactComponent as ICON } from '../../../assets/images/settings.svg';
import classNames from "classnames";
import Language from "../Language/Language";

const Settings = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const root = document.documentElement;

  const current_breakpoint = useAppSelector((state) => state.persist.current_breakpoint);
  const lockLayout = useAppSelector((state) => state.persist.locked_layout);
  const gridLayout = useAppSelector((state) => state.persist.grid_layout);
  const fontLayout = useAppSelector((state) => state.persist.font_layout);
  const isMFT = useAppSelector((state) => state.exchange.mftCached);

  const [isList, setIsList] = useState(false);
  const openTab = () => setIsList(!isList);


  const hanldeResetLayout = () => {
    dispatch(saveMobileTab("MARKET"));
    dispatch(saveFontSizeLayout(FONT_LAYOUT));
    console.log("GRID_LAYOUT", GRID_LAYOUT);
    dispatch(saveChangeGridLayout(GRID_LAYOUT, isMFT));
    dispatch(saveLockLayout(false));
  };

  const handleLockLayout = (event) => {
    const isChecked = event.target.checked;
    let lg_grid_layout = gridLayout.lg.slice();
    let md_grid_layout = gridLayout.md.slice();
    let sm_grid_layout = gridLayout.sm.slice();
    let xs_grid_layout = gridLayout.xs.slice();
    
    const lg_grid_locked = lg_grid_layout.map((el) =>{ return {...el, isResizable: !isChecked, isDraggable: !isChecked}});
    const md_grid_locked = md_grid_layout.map((el) =>{ return {...el, isResizable: !isChecked, isDraggable: !isChecked}});

    let new_grid_layout = {
      lg: lg_grid_locked,
      md: md_grid_locked,
      sm: sm_grid_layout,
      xs: xs_grid_layout,
    };

    dispatch(saveChangeGridLayout(new_grid_layout));
    dispatch(saveLockLayout(isChecked));
  }

  const handleCustomeView = async (event) => {
    const { name, checked } = event.target;

    let lg_grid_layout = gridLayout.lg.slice();
    let md_grid_layout = gridLayout.md.slice();
    let sm_grid_layout = gridLayout.sm.slice();
    let xs_grid_layout = gridLayout.xs.slice();

    if (checked) {
      let lg_item = GRID_LAYOUT.lg.find((doc) => doc.i === name);
      let md_item = GRID_LAYOUT.md.find((doc) => doc.i === name);

      if(lockLayout) {
        lg_item = {...lg_item, isResizable: false, isDraggable: false};
        md_item = {...md_item, isResizable: false, isDraggable: false};
      }

      lg_grid_layout.push(lg_item);
      md_grid_layout.push(md_item);
    } else {
      const lg_index = lg_grid_layout.findIndex((doc) => doc.i === name);
      const md_index = md_grid_layout.findIndex((doc) => doc.i === name);

      lg_grid_layout.splice(lg_index, 1);
      md_grid_layout.splice(md_index, 1);
    }

    let new_grid_layout = {
      lg: lg_grid_layout,
      md: md_grid_layout,
      sm: sm_grid_layout,
      xs: xs_grid_layout,
    };

    dispatch(saveChangeGridLayout(new_grid_layout));
  };

  useEffect(() => {
    root?.style.setProperty("--openOrder", `${fontLayout.openOrder}px`);
    root?.style.setProperty("--tableHead", `${fontLayout.tableHead}px`);
    root?.style.setProperty("--tableBody", `${fontLayout.tableBody}px`);
    root?.style.setProperty("--tickerHead", `${fontLayout.tickerHead}px`);
    root?.style.setProperty("--tickerArrow", `${fontLayout.tickerArrow}px`);
    root?.style.setProperty("--tickerPrice", `${fontLayout.tickerPrice}px`);
    root?.style.setProperty("--minFont", `${fontLayout.minFont}px`);
  }, [fontLayout.openOrder]);

  return (
    <div className="settings_wrapper">
      <button className={classNames("settingBtn", {"setting_active": isList})} onClick={openTab}> 
        <ICON />
      </button>
      {isList && <div className="black_dropdown_shadow" onClick={() => setIsList(false)}>
        <div className={"filter_show"} onClick={e => e.stopPropagation()}>
        <div className="filter_options">
          <p>{ t("filter_options.heading_text") }</p>
          <AdjustFontsize />
          <button
            disabled={current_breakpoint === "sm" || current_breakpoint === "xs"}
            className="layout_reset_btn"
            onClick={hanldeResetLayout}
          >
            {t("filter_options.resetbtn_text")}
          </button>
          <div className="themes_cont">
            <ThemesToggler />
          </div>
          <ul>
            {CUSTOMISE_VIEW_LIST.map((data, index) => (
              <li key={index}>
                <Form.Check
                  disabled={current_breakpoint === "sm" || current_breakpoint === "xs"}
                  checked={!!gridLayout.lg.find((doc) => doc.i === data.id)}
                  name={data.id}
                  id={data.id}
                  onChange={(event) => handleCustomeView(event)}
                  type="checkbox"
                  label={t(data.title)}
                />
              </li>
            ))}
          </ul>
          <div className="lock_cont">
            <Form.Check
              disabled={current_breakpoint === "sm" || current_breakpoint === "xs"}
              checked={lockLayout}
              id='lock'
              onChange={(event) => handleLockLayout(event)}
              type="checkbox"
              label={t("filter_options.lock_text")}
            />
          </div>
          <div className="lang_cont">
            Select Language:
            <Language />
          </div>
        </div>
      </div>
      </div>}
    </div>
  );
};

export default Settings;
